class AuthenticationController {
  constructor($state, $scope, $location, AuthenticationService, CONST, formlyConfig, FunctionService, $rootScope, V2Service) {

    FunctionService.resetFunctions();
    var splitUrl = $location.absUrl().split('?');
    // If logout was selected then sent logout type
    var logoutTypeParameter = splitUrl.length > 1 && splitUrl[1].toString() ? splitUrl[1] : '';
    var logoutType = logoutTypeParameter.indexOf('logout=true') > -1 ? 3 : 4;

    formlyConfig.extras.removeChromeAutoComplete=true;

    this.name = 'authentication';
    this.form = 'authentication';
    this.activeDirectoryErrorMsg = '';

    this.options = {
      removeChromeAutoComplete: true
    };

    this.userFields = [{
      "key": "username",
      "id": "username",
      "wrapper": "lx-wrapper-errors",
      "type": "lx-input",
      "templateOptions": {
        "label": "Email",
        "required": true,
        "icon": "account",
        "minlength": 1,
        "type": "email"
      },
      "modelOptions": {
        "allowInvalid": false,
        "updateOn": "keydown blur",
        "debounce": {
          "keydown": 100,
          "default": 100,
          "blur": 0
        }
      }
    }, {
      "key": "password",
      "id": "password",
      "wrapper": "lx-wrapper-errors",
      "type": "lx-input",
      "templateOptions": {
        type: "password",
        "label": "Password",
        "required": true,
        "icon": "key-variant",
        "minlength": 1,
      },
      "modelOptions": {
        "allowInvalid": false,
        "updateOn": "keydown blur",
        "debounce": {
          "keydown": 100,
          "default": 100,
          "blur": 0
        }
      }
    }];

    // reset login status
    // AuthenticationService.ClearCredentials(logoutType);

    // reset MYVIEW
    if ( typeof CONST != 'undefined' ) {
      CONST.MYVIEW.assignedCoder = undefined;
      CONST.MYVIEW.active = false;
      CONST.MYVIEW.selectedStatus = [];
      CONST.MYVIEW.selectedSpecialty = [];
      CONST.MYVIEW.selectedCriteria = [];
      CONST.MYVIEW.startDate = undefined;
      CONST.MYVIEW.startDateFormatted = undefined;
      CONST.MYVIEW.endDate = undefined;
      CONST.MYVIEW.endDateFormatted = undefined;
    }

    $scope.activeDirectoryError = function() {
      $scope.vm.activeDirectoryErrorMsg = $rootScope.activeDirectoryErrorMsg;
      return $rootScope.activeDirectoryError;
    }

    $scope.login = function() {
      $scope.dataLoading = true;

      AuthenticationService.Login($scope, function(response) {
        if (response.success) {
          AuthenticationService.SetCredentials(response.success.codingOperationsTeam,
            response.success.email,
            response.success.firstname + " " + response.success.lastname,
            response.success.specialty,
            response.success.dtype,
            response.success.worklist,
            response.success.id,
            response.success.token,
            response.success.roleId,
            'home',
            undefined,
            undefined,
            response.success.campus);

          const cfDomain = '.codefocus.com.au';
          const cfDomainIndex = window.location.hostname.indexOf(cfDomain) || window.location.hostname.indexOf('10.0.1.1');

          if (window.location.hostname.indexOf('localhost') > -1) {
            if (response.success.roleId) {
              window.location =  'http://localhost:4200/' + V2CONTEXT + '?token=' + response.success.token
                + '&roleId=' + response.success.roleId
                + '&redirectRoute=home';
            }
          } else if (cfDomainIndex > -1) {
            V2Service.redirectToV2(response.success.roleId);
          }
        } else {
          $scope.error = response.message;
          $scope.dataLoading = false;
        }
      });
    };
  }
}

export default AuthenticationController;



// WEBPACK FOOTER //
// ./client/app/components/authentication/authentication.controller.js